module.exports = __webpack_public_path__ + "img/about-us.32fd7ae9.jpg";